import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.exec.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.exec.js";
import FastClick from 'fastclick';
var UA = navigator.userAgent.toLowerCase();
var iosVersion = UA.match(/cpu iphone os (.*?) like mac os/);
// 修复ioS 聚焦问题
if (!iosVersion || parseInt(iosVersion[1]) < 11) {
  // 非IOS系统或者小于IOS11
  // 引入fastclick 做相关处理
  /**
   * @param {EventTarget|Element} targetElement
   */
  FastClick.prototype.focus = function (targetElement) {
    var length;

    // Issue #160: on iOS 7, some input elements (e.g. date datetime month) throw a vague TypeError on setSelectionRange. These elements don't have an integer value for the selectionStart and selectionEnd properties, but unfortunately that can't be used for detection because accessing the properties also throws a TypeError. Just check the type instead. Filed as Apple bug #15122724.
    if (iosVersion && targetElement.setSelectionRange && targetElement.type.indexOf('date') !== 0 && targetElement.type !== 'time' && targetElement.type !== 'month') {
      try {
        length = targetElement.value.length;
        targetElement.setSelectionRange(length, length);
        // 修复bug iOS 11.3以上不弹出键盘，加上聚焦代码，让其强聚焦弹窗键盘
        // 在手机端可能存在报错DOMException
        targetElement.focus();
      } catch (error) {
        console.log(error);
      }
    } else {
      targetElement.focus();
    }
  };
  // FastClick.attach(document.body)
}
export default FastClick;